// extracted by mini-css-extract-plugin
export default {"heading":"WelcomePage_heading__pMys8"};